import React, {useEffect, useState} from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import axios from 'axios';
import {t} from 'react-switch-lang';
import {BASE_URL, courtRiskId, incurredRiskId, potentialRiskId} from '../../utils/const';
import './TableWithNotification.scss';
import {getRisk, getCourtRisk} from '../../services/getRisk';
import {getMeasure} from '../../services/measuresService/measuresApi';

const TableWithDeleteNotification = ({message}) => {
  const [items, setItems] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const stylesWidth = {width: `100%`, minWidth: '150px'};

  const container_width = stylesWidth.length * 150 + 40;

  const containerStyles = {
    // maxHeight: "100%",
    minWidth: `${container_width + 20}px`,
    // paddingTop: "20px",
    // overflowY: "auto",
    // overflowX: "unset !important"
  };

  let riskLinkFun = (id) => {
    getRisk(id)
      .then((r) => {
        if (r.data.riskTypeId === potentialRiskId) {
          window.location = `/potential-risk/${id}`;
        } else if (r.data.riskTypeId === incurredRiskId) {
          window.location = `/incurred-risk/${id}`;
        } else if (r.data.riskTypeId === courtRiskId) {
          getCourtRisk(id).then((r) => {
            window.location = `/court-risk/${r.data[0].id}`;
          })
          .catch((r) => {
            window.location = '/403';
          });
        }
      })
      .catch((r) => {
        window.location = '/403';
      });
  };

  let riskId;
  let measuresLinkFun = (id) => {
    getMeasure(id).then((r) => {
      riskId = r.data.riskId;
      getRisk(riskId)
        .then((r) => {
          if (r.data.riskTypeId === potentialRiskId) {
            window.location = `/potential-risk/${riskId}?tab=measures&measure=${id}`;
          } else if (r.data.riskTypeId === incurredRiskId) {
            window.location = `/incurred-risk/${riskId}?tab=measures&measure=${id}`;
          } else if (r.data.riskTypeId === courtRiskId) {
            getCourtRisk(riskId).then((r) => {
              window.location = `/court-risk/${r.data[0].id}?tab=measures&measure=${id}`;
            })
            .catch((r) => {
              window.location = '/403';
            });
          }
        })
        .catch((r) => {
          window.location = '/403';
        });
    });
  };

  let revisionAndFindingLinkFun=(revisionId,findingID)=>{
    if (findingID){
      window.location = `/revisions/${revisionId}/findings/${findingID}`;
    }else{
      window.location = `/revisions/${revisionId}`;
    }
  }

  const fetchMoreData = () => {
    if (hasMore) {
      axios
        .get(
          `${BASE_URL}/notifications/deleted?page=${pageNumber}&sort=sentAt,desc`
        )
        .then((res) => {
          if (res.data.length !== 0) {
            const newData = items;
            res.data.map((item) => newData.push(item));
            setItems(newData);
            if (res.data.length < 20) {
              setHasMore(false);
            }
          } else {
            setIsLoading(false);
            setHasMore(false);
          }
          setPageNumber(pageNumber + 1);
        })
        .catch((r) => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    const fetchMoreData = () => {
      if (hasMore) {
        axios
          .get(
            `${BASE_URL}/notifications/deleted?page=${pageNumber}&sort=sentAt,desc`
          )
          .then((res) => {
            if (res.data.length !== 0) {
              const newData = items;
              res.data.map((item) => newData.push(item));
              setItems(newData);
              if (res.data.length < 20) {
                setHasMore(false);
              }
            } else {
              setIsLoading(false);
              setHasMore(false);
            }
            setPageNumber(pageNumber + 1);
          })
          .catch((r) => {
            setIsLoading(false);
          });
      }
    };
    fetchMoreData();
  }, []);

  return (
    <div>
      <div
        className="table-administration-container navbarNotification"
        id="table-container"
        style={containerStyles}
      >
        <InfiniteScroll
          dataLength={items.length}
          next={fetchMoreData && (() => fetchMoreData())}
          hasMore={hasMore}
          loader={isLoading ? <div className="loader"></div> : ''}
          scrollableTarget="table-container"
          scrollThreshold={0.7}
        >
          {items.length > 0 ? (
            items.map((item, index) => (
              <div className="navNotificationCard" key={index}>
                <div className="navNotificationHeader">
                  <div
                    className={`navNotificationColor ${item.notificationType.color}`}
                  ></div>
                  <div>
                    <div className="navNotificationSubject">{item.subject}</div>
                    {item.sentAt !== null ? (
                      <div className="navNotificationDate">
                        {item.sentAt
                          .slice(0, 10)
                          .split('-')
                          .reverse()
                          .join('.')}{' '}
                        - {item.sentAt.slice(11, 16)}h
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
                <div className="navNotificationBody">{item.body}</div>
                {item.riskId !== null ? (
                  <div className="navNotificationLink">
                    <br />
                    <p
                      onClick={() => riskLinkFun(item.riskId)}
                      className="w-100 d-block risk-link-p"
                      id={item.id}
                    >
                      {t(`notification.riskLink`)} {item.riskId}
                    </p>
                  </div>
                ) : item.measuresId !== null ? (
                  <div className="navNotificationLink">
                    <br />
                    <p
                      onClick={() => measuresLinkFun(item.measuresId)}
                      className="w-100 d-block risk-link-p"
                      id={item.id}
                    >
                      {t(`notification.measuresLink`)} {item.measuresId}
                    </p>
                  </div>
                ) : item.revisionId !== null ? (
                    <div className="navNotificationLink">
                      <br />
                      <p
                          onClick={() => revisionAndFindingLinkFun(item.revisionId,item.findingId)}
                          className="w-100 d-block risk-link-p"
                          id={item.id}
                      >
                        {item.findingId ? t(`notification.findingLink`) : t(`notification.revisionLink`)}
                      </p>
                    </div>
                ): (
                    ''
                )}
              </div>
            ))
          ) : (
            <div className="mx-auto navNoMessage text-center">
              <img src="/images/NoMessage.svg" alt="noMessage" />
              <br />
              {t(
                `notification.no${message.replace(/^\w/, (c) =>
                  c.toUpperCase()
                )}Message`
              )}
            </div>
          )}
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default TableWithDeleteNotification;
